import React from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';

import { clearWishList } from '../../../actions/wishlistActions'
import { logoutUser } from '../../../actions/userActions';
import { clearCashList } from '../../../actions/cartlistActions';

// import Custom Components
import PageHeader from '../../common/page-header';
import Breadcrumb from '../../common/breadcrumb';



function DashBoard(props) {

    let isLogged = props.isLogged;
    let user = props.user;

    let myOrders = props.myOrders;

    function logoutUserFunc() {
        /**props.clearCashList();
        props.clearWishList();
        props.logoutUser();*/
    }

    return (
        <>
            <Helmet>
                <title> Mon Profile</title>
            </Helmet>

            <h1 className="d-none"> Mon Profile</h1>

            <div className="main">
                <PageHeader title="Mon Profile" subTitle="Shop" />
                <Breadcrumb title="Mon Profile" parent1={["Shop", "shop/sidebar/list"]} adClass="mb-3" />

                {isLogged ?

                    <div className="page-content">
                        <div className="dashboard">
                            <div className="container">
                                <ul className="nav nav-dashboard flex-column mb-3 mb-md-0" role="tablist">
                                    <Tabs selectedTabClassName="active show">
                                        <div className="row">
                                            <aside className="col-md-4 col-lg-3">
                                                <TabList>
                                                    <Tab className="nav-item">
                                                        <span className="nav-link">Tableau De Bord</span>
                                                    </Tab>

                                                    <Tab className="nav-item">
                                                        <span className="nav-link">Mes Orders</span>
                                                    </Tab>

                                                    <Tab className="nav-item">
                                                        <span className="nav-link">Addresses</span>
                                                    </Tab>

                                                    {/*<Tab className="nav-item">
                                                        <span className="nav-link">Détails Du Compte</span>
                                                    </Tab>*/}

                                                    {/*<Tab className="nav-item">
                                                    <button className="nav-link" onClick={ logoutUserFunc() }>Sign Out</button>
                                                </Tab>*/}

                                                </TabList>
                                            </aside>

                                            <div className="col-md-8 col-lg-9" style={{ marginTop: "1rem" }}>
                                                <div className="tab-pane">
                                                    <TabPanel>
                                                        <p>Bienvenue <span className="font-weight-normal text-dark">{user.firstName} {user.lastName} </span>
                                                            {/*(not <span className="font-weight-normal text-dark">User</span>? <Link to="#">Log out</Link>)*/}
                                                            <br />
                                                            À partir du tableau de bord de votre compte, vous pouvez afficher votre <Link to="#tab-orders" className="tab-trigger-link link-underline">Dernières commandes</Link>, gère ton <Link to="#tab-address" className="tab-trigger-link">adresses de livraison et de facturation</Link>, et <Link to="#tab-account" className="tab-trigger-link">modifier votre mot de passe et les détails de votre compte</Link>.</p>
                                                    </TabPanel>

                                                    <TabPanel>
                                                        { myOrders ? 
                                                          myOrders.map( ( item, index ) =>
                                                          <div class="card card-dashboard" key={ index }>
                                                            <div class="card-body">
                                                                <p class="card-text"> Date du commande : { item.createdAt }</p>
                                                                <p class="card-text"> Nom du client : { item.fullName }</p>
                                                                <p class="card-text"> Numéro de télé : { item.phoneNumber }</p>
                                                                <p class="card-text"> Adress du client : { item.line1 }</p><p>{ item.line2 }</p>
                                                            </div>
                                                          </div>
                                                         )  : <p>Aucune commande n'a encore été passée.</p>
                                                        }
                                                        
                                                        <Link to={`${process.env.REACT_APP_PUBLIC_URL}/shop/sidebar/list`} className="btn btn-outline-primary-2"><span>VOIR LA BOUTIQUE</span><i className="icon-long-arrow-right"></i></Link>
                                                    </TabPanel>

                                                    <TabPanel>
                                                        <p>Les adresses suivantes seront utilisées par défaut sur la page de paiement.</p>

                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <div className="card card-dashboard">
                                                                    <div className="card-body">
                                                                        <h3 className="card-title">Adresse De Facturation</h3>

                                                                        <p> {user.username}<br />
                                                                            {user.firstName} {user.lastName}<br />
                                                                            {user._defaultAddress.line1}<br />
                                                                            {user._defaultAddress.line2}<br />
                                                                            {user._defaultPhoneNumber.phoneNumber}<br />
                                                                            {user.email}<br />
                                                                            {/*<Link to="#">Éditer <i className="icon-edit"></i></Link>*/}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {user.addresses.map(item =>

                                                                <div className="col-lg-6">
                                                                    <div className="card card-dashboard">
                                                                        <div className="card-body">
                                                                            <h3 className="card-title">Adresse De Livraison</h3>

                                                                            <p> {item.fullName}<br />
                                                                                {item.line1}<br />
                                                                                {item.line2}<br />
                                                                                {item.phoneNumber}<br />
                                                                                {item.email}<br />
                                                                                <br />
                                                                                {/*<Link to="#">Éditer <i className="icon-edit"></i></Link>*/}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )}
                                                        </div>
                                                    </TabPanel>

                                                    {/*<TabPanel>
                                                        <form action="#">
                                                            <div className="row">
                                                                <div className="col-sm-6">
                                                                    <label>Prénom *</label>
                                                                    <input type="text" className="form-control" required value={user.firstName} />
                                                                </div>

                                                                <div className="col-sm-6">
                                                                    <label>Nom De Famille *</label>
                                                                    <input type="text" className="form-control" required value={user.lastName} />
                                                                </div>
                                                            </div>

                                                            <label>Nom D'Utilisateur *</label>
                                                            <input type="text" className="form-control" required value={user.username} />
                                                            <small className="form-text">Ce sera ainsi que votre nom sera affiché dans la section du compte et dans les avis.</small>

                                                            <label>Adresse e-mail *</label>
                                                            <input type="email" className="form-control" required value={user.email} />

                                                            <label>Mot de passe actuel (laissez vide pour laisser inchangé)</label>
                                                            <input type="password" className="form-control" />

                                                            <label>Nouveau mot de passe (laissez vide pour laisser inchangé)</label>
                                                            <input type="password" className="form-control" />

                                                            <label>Confirmer le nouveau mot de passe</label>
                                                            <input type="password" className="form-control mb-2" />

                                                            <button type="submit" className="btn btn-outline-primary-2">
                                                                <span>SAUVEGARDER LES MODIFICATIONS</span>
                                                                <i className="icon-long-arrow-right"></i>
                                                            </button>
                                                        </form>
                                                    </TabPanel>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </Tabs>
                                </ul>
                            </div>
                        </div>
                    </div>
                    :
                    <div class="container" style={{ textAlign: 'center', marginBottom: '5%', marginTop: '5%' }}>
                        <p style={{ fontSize: '55px', fontWeight: 'bold' }}>vous devez d'abord vous connecter</p>
                    </div>
                }

            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        isLogged: state.user.isLogged ? state.user.isLogged : false,
        user: state.user.user ? state.user.user : {},
        myOrders: state.usercartlist.my_orders ? state.usercartlist.my_orders : [],
    }
}

//export default connect( null, { clearCashList, clearWishList, logoutUser }) (React.memo( DashBoard ));
export default connect(mapStateToProps, null)(React.memo(DashBoard));